var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramDental40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dentatl40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.500000, 9.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59722993,5 C13.4947952,5 16.7188645,2.00606086 17,1.2069524 C17.2633277,-0.586095205 13.1304709,0.486820968 9.5,1.2069524 C6.17973579,0.496522203 2.27186594,0.0154204574 2.27186594,1.2069524 C2.27186594,2.39848434 5.69966463,5 9.59722993,5 Z",
    id: "Oval",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1 C4.61821664,3.66666667 7.11821664,5 9.5,5 C11.8817834,5 14.2494591,3.66666667 16.6030273,1 L19,3 L17.9924316,9.10424805 L16.6030273,12.5109863 C15.561336,17.930287 14.4985008,20.7599582 13.4145219,21 C11.7885534,21.3600627 11.6596095,14.0524902 9.64191539,14.0524902 C7.62422129,14.0524902 6.95947266,20.5899658 5.45445521,21 C4.45111025,21.2733561 3.39024716,18.3190104 2.27186594,12.1369629 L0,6.22167969 L0.475585937,1.98657227 L2,1 Z",
    id: "Path-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,1.56495548 C11.6241225,1.56495548 11.9803742,0 13.7887081,0 C15.597042,0 18.3574617,0.946562584 18.8302155,3.17339171 C19.3029692,5.40022083 18.7019962,6.45484115 18.085799,8.32688044 C17.4696019,10.1989197 16.4678161,11.6762265 16.4678161,12.7184179 C16.4678161,13.7606093 16.1741451,21 13.4145219,21 C10.6548987,21 12.1472277,14.0671709 9.5,14.0671709 C6.85277229,14.0671709 8.25200897,21 5.45445521,21 C2.65690146,21 2.34321801,13.6627582 2.34321801,12.7184179 C2.34321801,11.7740776 1.75005842,10.0637921 0.932573282,8.32688044 C0.115088143,6.5899688 -0.187890977,5.18810271 0.115088143,3.17339171 C0.418067264,1.15868071 3.02247765,0 5.10400471,0 C7.18553177,0 7.37587753,1.56495548 9.5,1.56495548 Z",
    id: "Path-7",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1 C4.4374639,3.66666667 6.96910997,5 9.59493821,5 C12.2207664,5 14.6891204,3.66666667 17,1",
    id: "Path-9",
    stroke: "#4F4C4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramDental40);
export default __webpack_public_path__ + "static/media/pictogramDental40.b97abb0332574d7ccf006b10bf75961a.svg";
export { ForwardRef as ReactComponent };